import {
  DuplicateStepDocument,
  DuplicateStepMutation,
  DuplicateStepMutationVariables,
  GetProcessDetailDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDuplicateStep = () => {
  const [DuplicateStep, { loading }] = useMutation(DuplicateStepDocument, {
    extractorFn: (data: DuplicateStepMutation) => data.processesMutations.duplicateProcessesStep,
  })

  return {
    loading,
    duplicateStep(variables: DuplicateStepMutationVariables, processId: number) {
      return DuplicateStep({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetProcessDetailDocument,
            variables: {
              id: processId,
            },
          },
        ],
      })
    },
  }
}
